import React from 'react';
import { FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';
import logo from '../assets/images/logo.png';

const Footer = () => {
  const { language } = useLanguage();

  const footerContent = {
    fr: {
      description: "La société K'MDEU FARMS SARL est une entreprise agricole dynamique fondée de fait en 2017 et formalisée en 2020.",
      location: "Localisation",
      cameroon: "Cameroun :",
      address: "BONEPOUPA dans le Département du NKAM - 45KM de DOUALA",
      contact: "Contact",
      email: "Email:",
      phone: "Téléphone:",
      copyright: "© 2024 K'MDEU FARMS SARL. Tous droits réservés."
    },
    en: {
      description: "K'MDEU FARMS SARL is a dynamic agricultural company founded in fact in 2017 and formalized in 2020.",
      location: "Location",
      cameroon: "Cameroon:",
      address: "BONEPOUPA in NKAM Department - 45KM from DOUALA",
      contact: "Contact",
      email: "Email:",
      phone: "Phone:",
      copyright: "© 2024 K'MDEU FARMS SARL. All rights reserved."
    }
  };

  const currentFooterContent = footerContent[language];

  return (
    <footer style={{ backgroundColor: 'green', color: 'white', padding: '20px', textAlign: 'center' }}>
      <div className="container">
        <div className="row">
          {/* Colonne 1 : Logo et description */}
          <div className="col-md-4 mb-4">
            <img
              src={logo}
              alt="K'MDEU FARMS Logo"
              className="img-fluid mb-3"
              style={{ width: '150px' }}
            />
            <p>
              {currentFooterContent.description}
            </p>
          </div>

          {/* Colonne 2 : Localisation */}
          <div className="col-md-4 mb-4">
            <h5>{currentFooterContent.location}</h5>
            <p>
              <strong>{currentFooterContent.cameroon}</strong> {currentFooterContent.address}
            </p>
          </div>

          {/* Colonne 3 : Contact et réseaux sociaux */}
          <div className="col-md-4 mb-4">
            <h5>{currentFooterContent.contact}</h5>
            <p>
              {currentFooterContent.email} <a href="mailto:hello@kamadeu.com" className="text-white">hello@kamadeu.com</a>
              <br />
              {currentFooterContent.phone} <a href="tel:+237678476043" className="text-white">+237 678476043</a>
            </p>
            <div className="social-icons">
              <a href="https://www.facebook.com/profile.php?id=61579258947958" className="text-white me-3">
                <FaFacebook size={24} />
              </a>
              {/*
              <a href="https://twitter.com/clinicagro" className="text-white me-3">
                <FaTwitter size={24} />
              </a>
              <a href="https://www.linkedin.com/company/69382632" className="text-white">
                <FaLinkedin size={24} />
              </a>
              */}
            </div>
          </div>
        </div>

        {/* Ligne horizontale */}
        <hr className="bg-light" />

        {/* Copyright */}
        <div className="text-center pt-3">
          <p>{currentFooterContent.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;